module.exports = __webpack_public_path__ + "media/images/front/top/news-5fb07046e53465ea5be165dcc6007e08.jpg";